import { render, staticRenderFns } from "./phone-number-provider.vue?vue&type=template&id=dd006524"
import script from "./phone-number-provider.vue?vue&type=script&lang=js"
export * from "./phone-number-provider.vue?vue&type=script&lang=js"
import style0 from "./phone-number-provider.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/payments/phone-number-provider.vue
// module id = MVDk
// module chunks = 0